import React from 'react';
import { Route, Routes } from 'react-router-dom';
import AuthOutlet from './AuthOutlet';
import Login from './Login';
import Signup from './Signup';
import ForgotPassword from './ForgotPassword';
import { Logout } from './Logout';
import PublicPageOutlet from './PublicPageOutlet';
import VendorsInfo from '../vendors/VendorsInfo';
import Home from '../landingPage/pages/home';
import BlogListing from '../blog';
import Onboarding from '../onboarding';
import { useEffect } from 'react';
import { useLocation } from 'react-router';
import NotFound404 from '../landingPage/pages/notfound';
// import NewDashBoard from '../dashboard/newdashboard';
import Social from '../Social';
import OurVideos from '../our-videos';

const AuthRoutes = () => (
  <ScrollToTop>
    <Routes>
      <Route element={<PublicPageOutlet />}>
        <Route path="/" element={<Home />} />
        <Route path="/blogs/*" element={<BlogListing />} />
        <Route path="/florists" element={<VendorsInfo />} />
        <Route path="/social" element={<Social />} />
        <Route path="/our-videos" element={<OurVideos />} />

        <Route path="*" element={<NotFound404 />} />
      </Route>

      <Route element={<AuthOutlet />}>
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/reset-password" element={<ForgotPassword />} />
        <Route path="*" element={<NotFound404 />} />
      </Route>
      <Route path="/onboarding" element={<Onboarding />} />
      <Route path="/logout" element={<Logout />} />
    </Routes>
  </ScrollToTop>
);

const ScrollToTop = (props) => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return <>{props.children}</>;
};

export default AuthRoutes;
